import React from "react";
import PropTypes from "prop-types";
import {OneMinInstallation} from "../icons";
import Link from "next/link";
import { useTranslation } from "next-i18next";

const CardWithIcon = (props:{ icon: any; title: string ; description: string, link?: string }) => {
    const { t } = useTranslation("common");
    return (
        <>
            <div className={'card-item'}>
                {props.icon}
                <h4>{props.title}</h4>
                <p>{props.description}</p>
                {props.link != null ? <p className={"blog-page-read"}><Link href={props.link} className={"read-more"}>{t('cta.learnMore')}</Link></p> : ""}
            </div>
        </>
    )
}
CardWithIcon.defaultProps = {
    icon: <OneMinInstallation />,
    title: "20%",
    description: "Enhanced clarity and real-time log monitoring accelerate bug detection and resolution.",
    link: null,
}
CardWithIcon.propTypes = {
    icon: PropTypes.any,
    title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string
}
export default CardWithIcon;